import { ScrollArea } from "@base-ui/react/scroll-area"
import React from "react"

import classNames from "classnames"

import { WithClassName } from "shared/types/WithClassName"
import { DataTable } from "shared/types/__generated__/graphql"
import { Skeleton } from "shared/ui/skeleton/Skeleton"

import { Label } from "../label/Label"
import { DataTableHeader } from "./DataTableHeader"
import { DataTableRow } from "./DataTableRow"
import "./styles/_data-table.scss"

interface DataTableViewProps extends WithClassName {
  id: string
  data: DataTable | null | undefined
  label: string
  hideLabel?: boolean
  isLoading?: boolean
  loadingLines?: number
}

export const DataTableView = React.memo(
  ({
    id,
    data,
    label,
    hideLabel = true,
    isLoading,
    className,
    loadingLines = 6
  }: DataTableViewProps) => {
    if (isLoading) return <Skeleton count={loadingLines} />
    return data ? (
      <div
        id={id}
        className={classNames("data-table", className)}
        data-testid="data-table"
      >
        {hideLabel ? null : <Label>{label}</Label>}
        <ScrollArea.Root className="data-table__scroll-area scroll-area scroll-area--horizontal shadow-s">
          <ScrollArea.Viewport className="scroll-area__viewport">
            <ScrollArea.Content className="scroll-area__content">
              <table className="data-table__table">
                <caption className="visually-hidden">{label}</caption>
                <DataTableHeader header={data.header} />
                <tbody
                  data-testid="data-table-body"
                  className="data-table__body"
                >
                  {data.body?.map((row, index) => (
                    <DataTableRow
                      // eslint-disable-next-line react/no-array-index-key
                      key={`${id}-${index}`}
                      row={row}
                    />
                  ))}
                </tbody>
              </table>
            </ScrollArea.Content>
          </ScrollArea.Viewport>
          <ScrollArea.Scrollbar
            orientation="horizontal"
            className="scroll-area__scrollbar"
          >
            <ScrollArea.Thumb className="scroll-area__thumb" />
          </ScrollArea.Scrollbar>
        </ScrollArea.Root>
      </div>
    ) : null
  }
)
